<template>
  <b-modal
    id="reject-job-modal"
    :visible="visible"
    size="sm"
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
    @close="onModalClose"
  >
    <div class="d-block text-center">
      <h5 class="mb-4 mt-2">{{ $t('modals.reject-job.title') }}</h5>
      <b-row class="justify-content-center">
        <b-col cols="5">
          <b-button class="w-100" variant="primary" @click="onRejectJob">
            {{ $t('yes') }}
          </b-button>
        </b-col>
        <b-col cols="5">
          <b-button class="w-100" variant="primary" @click="onModalClose">
            {{ $t('no') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'RejectJobModal',
  props: {
    visible: Boolean,
  },
  methods: {
    onRejectJob() {
      this.$emit('close');
    },
    onModalClose() {
      this.$emit('close');
    },
  },
};
</script>
